export const environment = {
  production: true,
  backendEnv: 'production',
  displayEnvBanner: false,
}
